export default __webpack_public_path__ + "static/media/partner-call.9cad59e8.wav";